var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 31,
    viewBox: "0 0 28 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.45333 17.5385L18.56 22.9115M18.5467 8.0885L9.45333 13.4615M26 6.05C26 8.28675 24.2091 10.1 22 10.1C19.7909 10.1 18 8.28675 18 6.05C18 3.81325 19.7909 2 22 2C24.2091 2 26 3.81325 26 6.05ZM10 15.5C10 17.7368 8.20914 19.55 6 19.55C3.79086 19.55 2 17.7368 2 15.5C2 13.2632 3.79086 11.45 6 11.45C8.20914 11.45 10 13.2632 10 15.5ZM26 24.95C26 27.1868 24.2091 29 22 29C19.7909 29 18 27.1868 18 24.95C18 22.7132 19.7909 20.9 22 20.9C24.2091 20.9 26 22.7132 26 24.95Z",
    stroke: "#FF7B9A",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.d8bbf0b59954dc846d03da991f855b61.svg";
export { ForwardRef as ReactComponent };